/* eslint-disable @typescript-eslint/consistent-indexed-object-style */
import type { ITypographyCommon } from "@/types/common";
import { type HTMLAttributes } from "react";

import { StyledWrapperDiplay } from "./styles";

export interface IDisplay extends Omit<ITypographyCommon, "sizeVariant">, HTMLAttributes<HTMLHeadingElement> {
  [key: string]: any;
}

const Display = ({ size, color, ...props }: IDisplay) => {
  return <StyledWrapperDiplay {...props} $size={size} $color={color} />;
};

export default Display;
